import { Document } from 'jsonapi-typescript';
import { Observable } from 'rxjs';
import { User } from '../interfaces/user.interface';
import { deserializer } from './deserializer';
import { MetaNew } from '../interfaces/meta-new.interface';

export function deserializeUsers(users: Document): Observable<{ users: User[]; meta: MetaNew }> {
	return new Observable<{ users: User[]; meta: MetaNew }>((observer) => {
		deserializer.deserialize(users, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				const data: any[] = Array.isArray(response) ? response : [response];
				observer.next({ users: data, meta: (users as any)?.meta });
				observer.complete();
			}
		});
	});
}

export function deserializeUser(user: Document): Observable<User> {
	return new Observable<User>((observer) => {
		deserializer.deserialize(user, (err: Error, response: any) => {
			if (err) {
				observer.error(err);
			} else {
				if (response.settings) {
					response.format = response.settings.format;
					response.lang = response.settings.language;
					response.theme = response.settings.theme;
					delete response.settings;
				}

				/**
				 * TODO: should be removed once the new auth service is used everywhere!
				 */
				response.firstname = response.first_name;
				response.lastname = response.last_name;

				observer.next(response);
				observer.complete();
			}
		});
	});
}
